const NATIVE_SIZE = 168.37;
const SCALE = 1.5; // was 3 — now 2x smaller
const SIZE = NATIVE_SIZE * SCALE;

function loadScript(src) {
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    document.head.appendChild(s);
  });
}

loadScript("https://cdnjs.cloudflare.com/ajax/libs/matter-js/0.19.0/matter.min.js").then(() => {
  const { Engine, Runner, Bodies, Composite, Events, Vertices } = Matter;

  const wrapper = document.createElement("div");
  wrapper.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    pointer-events: none;
    z-index: 9999;
  `;
  document.body.appendChild(wrapper);

  const engine = Engine.create();
  const world = engine.world;
  engine.gravity.y = 1;

  Runner.run(engine);

  let floor, wallLeft, wallRight;

  function createBounds() {
    if (floor) Composite.remove(world, [floor, wallLeft, wallRight]);

    const w = window.innerWidth;
    const h = window.innerHeight;
    floor = Bodies.rectangle(w / 2, h + 40, w, 80, { isStatic: true });
    wallLeft = Bodies.rectangle(-40, h / 2, 80, h, { isStatic: true });
    wallRight = Bodies.rectangle(w + 40, h / 2, 80, h, { isStatic: true });

    Composite.add(world, [floor, wallLeft, wallRight]);
  }

  createBounds();
  window.addEventListener("resize", createBounds);

  const code = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
  let input = [];

  document.addEventListener("keydown", (e) => {
    input.push(e.keyCode);
    if (input.toString().includes(code.toString())) {
      triggerKonami();
      input = [];
    }
  });

  function triggerKonami() {
    const shapes = [
      triangleSVG(),
      rotatedSquareSVG(),
      tallRectSVG(),
      organicBlobSVG(),
      circleSVG(),
            styledLogoSVG()

    ];

    for (let i = 0; i < shapes.length; i++) {
      for (let j = 0; j < 3; j++) {
        spawnShape(shapes[i]);
      }
    }
  }

  function spawnShape({ svgMarkup, bodyFn }) {
    const startX = 100 + Math.random() * (window.innerWidth - 200);
    const startY = -Math.random() * 200;

    const div = document.createElement("div");
    div.innerHTML = svgMarkup.trim();
    const svg = div.querySelector("svg");

    svg.style.cssText = `
      position: absolute;
      width: ${SIZE}px;
      height: ${SIZE}px;
      transform: translate(-9999px, -9999px);
      pointer-events: none;
    `;
    wrapper.appendChild(svg);

    const body = bodyFn(startX, startY);
    Composite.add(world, body);

    Events.on(engine, "afterUpdate", () => {
      svg.style.transform = `translate(${body.position.x - SIZE / 2}px, ${body.position.y - SIZE / 2}px) rotate(${body.angle}rad)`;
    });
  }

  // SVG + Body Definitions

  function styledLogoSVG() {
  return {
    svgMarkup: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
      <path d="M34.68,0c19.15,0,34.54,14.15,34.54,33.57,0,19.28-15.54,33.43-34.54,33.43C15.81,67,0,52.85,0,33.57,0,14.15,15.67,0,34.68,0ZM61.86,33.57c0-15.53-11.79-26.77-27.19-26.77-15.4,0-27.33,11.24-27.33,26.77,0,15.41,12.21,26.5,27.33,26.5,15.26,0,27.19-11.09,27.19-26.5ZM48.68,45.64c.15,2.08.7,3.74,1.67,5.13h-7.22c-.69-.97-1.24-2.77-1.39-5.13l-.27-3.61c-.42-3.87-1.39-4.99-4.72-4.99h-8.6s0,13.73,0,13.73h-6.94s0-35.38,0-35.38h15.4c7.77,0,12.62,3.61,12.62,10.13,0,4.02-1.66,6.66-5.13,8.19,2.63,1.11,4.02,3.47,4.16,6.94l.42,4.99ZM28.16,31.07h8.6c3.47,0,5.27-1.52,5.27-4.71,0-3.2-1.94-4.72-5.69-4.72h-8.18s0,9.43,0,9.43Z"
        fill="#000000"/>
    </svg>`,
    bodyFn: (x, y) =>
      Bodies.rectangle(
        x,
        y,
        70 * SCALE,
        70 * SCALE,
        getPhysicsOptions()
      )
  };
}

  function triangleSVG() {
    return {
      svgMarkup: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.37 168.37">
        <polygon points="84.18 27.95 19.25 140.42 149.12 140.42 84.18 27.95" fill="#db3b26"/>
      </svg>`,
      bodyFn: (x, y) => {
        const verts = Vertices.scale([
          { x: 84.18, y: 27.95 },
          { x: 19.25, y: 140.42 },
          { x: 149.12, y: 140.42 }
        ], SCALE, SCALE);
        return Bodies.fromVertices(x, y, verts, getPhysicsOptions(), true);
      }
    };
  }

  function rotatedSquareSVG() {
    return {
      svgMarkup: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.37 168.37">
        <rect x="33.86" y="33.87" width="100.65" height="100.62"
              transform="translate(-34.87 84.21) rotate(-45.01)"
              fill="#219d30"/>
      </svg>`,
      bodyFn: (x, y) => Bodies.rectangle(x, y, 100.65 * SCALE, 100.65 * SCALE, getPhysicsOptions())
    };
  }

  function tallRectSVG() {
    return {
      svgMarkup: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.37 168.37">
        <rect x="47.65" y="3.71" width="73.07" height="160.95" fill="#000000"/>
      </svg>`,
      bodyFn: (x, y) => Bodies.rectangle(x, y, 73.07 * SCALE, 160.95 * SCALE, getPhysicsOptions())
    };
  }

  function organicBlobSVG() {
    return {
      svgMarkup: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.37 168.37">
        <path d="M18.84,149.53c36.1-36.1,94.6-36.09,130.69,0h0c-36.09-36.09-36.1-94.6,0-130.69-36.1,36.1-94.6,36.09-130.69,0h0c36.09,36.09,36.1,94.6,0,130.69Z"
              fill="#efb523"/>
      </svg>`,
      bodyFn: (x, y) => Bodies.circle(x, y, 85 * SCALE, getPhysicsOptions()) // approximated as circle
    };
  }

  function circleSVG() {
    return {
      svgMarkup: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.37 168.37">
        <circle cx="88.26" cy="84.18" r="60.87" fill="#006fd3"/>
      </svg>`,
      bodyFn: (x, y) => Bodies.circle(x, y, 60.87 * SCALE, getPhysicsOptions())
    };
  }

function getPhysicsOptions() {
  return {
    restitution: 0.2,        // higher = more bounce
    friction: 0.01,
    frictionAir: 0,          // remove air drag
    density: 0.001,
  };
}
});
